import type { EditionType } from '@/app/[locale]/(app)/(workspace)/(main)/subscription/types';

/**
 * 根据当前空间类型计算订阅页路径，避免调用方写死 /personal 后被页面 effect 二次 redirect 到 /team。
 *
 * @param isTeamSpace 当前是否在团队空间下
 * @param query 可选 query 串（不带前导 ?），例如 'tab=credits'
 */
export const getSubscriptionUrl = (isTeamSpace: boolean | undefined, query?: string): string => {
  const edition: EditionType = isTeamSpace ? 'team' : 'personal';
  const base = `/subscription/${edition}`;
  return query ? `${base}?${query}` : base;
};
